export const isValidEmail = (email) => {
	const emailVerifyRegex =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return emailVerifyRegex.test(String(email).toLowerCase())
}

export const isValidPassword = (password) => {
	const passwordVerifyRegex =
		/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~@#$%^&*+=`|{}:;!.?"()[\]-]{8,25}$/
	return passwordVerifyRegex.test(password)
}

export const isValidPhoneNumber = (phone) => {
	const phoneVerifyRegex = /^([2-9]{1}[0-9]{2})[0-9]{3}[0-9]{4}$/
	return phoneVerifyRegex.test(phone)
}

export const isValidFFLNumber = (fflNumber) => {
	const fflVerifyRegex = /^[0-9]{9}[a-zA-Z]{1}[0-9]{5}$/
	return fflVerifyRegex.test(fflNumber)
}

export const isValidZipcode = (zipcode) => {
	const formattedZipCode = zipcode.replace(/-/g, '')
	const zipcodeVerifyRegex =
		formattedZipCode.length === 9 ? /^[0-9]{9}$/ : /^[0-9]{5}$/
	return zipcodeVerifyRegex.test(formattedZipCode)
}

export const getIntegerCharacter = (value) => value && value.replace(/\D/g, '')

export const ACCEPTED_CARDS = {
	Visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
	Mastercard:
		/^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/,
	American_Express: /^3[47][0-9]{13}$/,
	Discover:
		/^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
	Diners_Club: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
	JCB: /^(?:2131|1800|35[0-9]{3})[0-9]{11}$/,
}
